import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  roomTypeRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 40,
    alignItems: 'center',
    backgroundColor: theme.palette.grey[400]
  },
  roomTypeRowForMonth: {
    gridTemplateColumns: '9.122fr 2.878fr repeat(31,1fr)'
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%'
  },
  roomIcon: {
    display: 'flex',
    alignItems: 'center',
    width: 30
  },
  openAllArrowRight: {
    marginRight: 6,
    fontSize: 35,
    cursor: 'pointer',
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  openAllArrowDown: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  rowName: {
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15
  },
  numberOfRatePlans: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  ratePlansLoading: {
    width: 14,
    marginRight: 6,
    marginLeft: 4,
    marginTop: 4
  },
  roomTypeArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  roomTypeArrowDown: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  emptyBox: {
    height: '100%',
    borderLeft: `1px solid ${theme.palette.grey[100]}`
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2',
    borderLeft: `1px solid ${theme.palette.grey[400]}`,
    borderTop: `1px solid ${theme.palette.grey[400]}`
  }
}))

export default useStyles
